import { isImperial } from "~/helpers/userPreference";
import styles from "./VisualMapColorScaler.module.less";
import { useCallback, useMemo } from "react";
import { Typography } from "antd";
import { HeatMapVisualMapColor } from "../../../laserScanScene/constant/laserScene";

export interface VisualMapColorScalerProps {
  colorScale: HeatMapVisualMapColor[];
  converter?: (value: number) => number;
}
const VisualMapColorScaler: React.FC<VisualMapColorScalerProps> = ({
  colorScale,
  converter,
}) => {
  const isImperialUnit = useMemo(() => isImperial(), []);

  const getColorBrightnessAndThreshold = useCallback((color: string) => {
    const red = parseInt(color.slice(1, 3), 16);
    const green = parseInt(color.slice(3, 5), 16);
    const blue = parseInt(color.slice(5, 7), 16);

    const brightness = 0.299 * red + 0.587 * green + 0.114 * blue;

    const brightnessThreshold = 128;

    return { backgroundColor: color, brightness, brightnessThreshold };
  }, []);

  const prepareScaleForRender = useCallback(
    (value: number) => {
      const convertedValue = converter ? converter(value) : value;

      return Number.isInteger(convertedValue)
        ? convertedValue
        : isImperialUnit
          ? convertedValue.toFixed(2)
          : convertedValue < 0
            ? Math.ceil(convertedValue)
            : convertedValue.toFixed(0);
    },
    [converter, isImperialUnit],
  );

  return (
    <div className={styles.lidarColorScale}>
      <table className={styles.scaleTable}>
        <thead>
          <tr className={styles.scaleRow}>
            {colorScale.map((x, i, list) => {
              const { backgroundColor, brightness, brightnessThreshold } =
                getColorBrightnessAndThreshold(x.color);
              return (
                <td
                  className={styles.scaleColumn}
                  key={i}
                  style={{
                    backgroundColor,
                  }}
                >
                  <Typography.Title
                    level={4}
                    style={{
                      color:
                        brightness < brightnessThreshold ? "white" : "black",
                      fontSize: isImperialUnit ? undefined : "11px",
                    }}
                    className={styles.scaleValue}
                  >
                    {prepareScaleForRender(x.min)}
                    {i < list.length - 1 && x.max
                      ? "-" + prepareScaleForRender(x.max)
                      : " < "}
                  </Typography.Title>
                </td>
              );
            })}
          </tr>
        </thead>
      </table>
    </div>
  );
};

export default VisualMapColorScaler;
